import React, { useState } from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as ArrowDownIcon } from "../../assets/images/ArrowDown.svg";
import { styled } from "@mui/system";
import {
  CLIENT_ADMIN_ROLE_ID,
  VF_ADMIN_ROLE_ID,
} from "../../constants/constant";
import { useSelector } from "react-redux";

export default function AddNewDropdown() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const userRole = useSelector((state) => state?.user?.userRoleId);
  const isVFAdmin = userRole?.includes(VF_ADMIN_ROLE_ID);
  const isClientAdmin = userRole?.includes(CLIENT_ADMIN_ROLE_ID);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const buttonStyle = {
    backgroundColor: "#f7954c",
    borderRadius: "4px",
    // width: "160px",
    width: "auto",
    height: "48px",
    marginLeft: "auto",
    lineHeight: "40px",
    textAlign: "center",
    "&:hover": {
      backgroundColor: "#f7954c",
    },
  };

  const buttonText = {
    fontSize: "16px",
    letterSpacing: "-0.02em",
    fontFamily: "Montserrat",
    color: "#fff",
    textAlign: "center",
    textTransform: "capitalize",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    lineHeight: "24px",
    fontWeight: 600,
    padding: "0 10px",
  };

  const handleClick = (event) => {
    !isVFAdmin ? navigate("/add-user") : setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  return (
    <div>
      <Button
        sx={buttonStyle}
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
        disableElevation={true}
      >
        <Typography sx={buttonText}>
          + Add {!isVFAdmin ? "User" : "New"}
          {isVFAdmin && (
            <span style={{ marginLeft: "4px", marginTop: "10px" }}>
              <ArrowDownIcon />
            </span>
          )}
        </Typography>
      </Button>
      <StyledPopover
        style={{ minWidth: "200px" }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box
          sx={{ width: "200px", maxWidth: 360, bgcolor: "background.paper" }}
        >
          <List component="nav" aria-label="secondary mailbox folder">
            <ListItemButton
              selected={selectedIndex === 0}
              onClick={(event) => handleListItemClick(event, 0)}
              component={Link}
              to="/add-user"
              style={{ backgroundColor: selectedIndex === 0 ? "#d9d9d9" : "" }}
            >
              <ListItemText primary="User" />
            </ListItemButton>
            <Divider sx={{ margin: "0px 12px" }} />
            <ListItemButton
              selected={selectedIndex === 1}
              onClick={(event) => handleListItemClick(event, 1)}
              component={Link}
              to="/add-organisation"
              style={{ backgroundColor: selectedIndex === 1 ? "#d9d9d9" : "" }}
            >
              <ListItemText primary="Organisation" />
            </ListItemButton>
            <Divider sx={{ margin: "0px 12px" }} />
            <ListItemButton
              selected={selectedIndex === 2}
              onClick={(event) => handleListItemClick(event, 2)}
              component={Link}
              to="/add-report"
              style={{ backgroundColor: selectedIndex === 2 ? "#d9d9d9" : "" }}
            >
              <ListItemText primary="Report" />
            </ListItemButton>
          </List>
        </Box>
      </StyledPopover>
    </div>
  );
}

const StyledPopover = styled(Popover)(({ theme }) => ({
  "& .MuiPaper-root": {
    boxShadow: "none",
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
  },
  "& .MuiListItemText-primary": {
    fontSize: "14px",
    letterSpacing: "-0.02em",
    fontWeight: 500,
    fontFamily: "Montserrat",
    color: "#5a5a5a",
    textAlign: "left",
  },
  "& .MuiList-root": {
    padding: 0,
  },
}));
